import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Address } from '../../models/Address'

@Component({
    selector: 'address-block',
    templateUrl: './address-block.component.html',
    styleUrls: ['./address-block.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddressBlockComponent {
    @Input() address: Address;
    @Input() showAddressTitle: boolean = true;
}
